const statusOrder = [
  "Pending",
  "Confirmed",
  "Packed",
  "Shipped",
  "Delivered",
  "Cancelled",
  "Returned",
];

const courierOptions = [
  { name: "Blue Dart", slaHours: 24, cost: 120, rating: 4.8 },
  { name: "Delhivery", slaHours: 36, cost: 95, rating: 4.5 },
  { name: "DTDC", slaHours: 48, cost: 80, rating: 4.2 },
  { name: "Xpressbees", slaHours: 30, cost: 100, rating: 4.4 },
  { name: "Shadowfax", slaHours: 28, cost: 105, rating: 4.3 },
];

const cities = [
  { city: "Mumbai", state: "Maharashtra", pincode: "400058" },
  { city: "Delhi", state: "Delhi", pincode: "110016" },
  { city: "Bengaluru", state: "Karnataka", pincode: "560102" },
  { city: "Hyderabad", state: "Telangana", pincode: "500033" },
  { city: "Pune", state: "Maharashtra", pincode: "411038" },
  { city: "Chennai", state: "Tamil Nadu", pincode: "600090" },
  { city: "Ahmedabad", state: "Gujarat", pincode: "380015" },
  { city: "Jaipur", state: "Rajasthan", pincode: "302017" },
  { city: "Kolkata", state: "West Bengal", pincode: "700019" },
  { city: "Lucknow", state: "Uttar Pradesh", pincode: "226010" },
];

const customerNames = [
  "Riya Sharma",
  "Arjun Patel",
  "Sneha Verma",
  "Dev Mehta",
  "Aman Khan",
  "Pooja Nair",
  "Nikhil Rao",
  "Ishita Jain",
  "Kabir Singh",
  "Meera Iyer",
  "Rahul Joshi",
  "Ananya Das",
  "Sana Ali",
  "Vikram Reddy",
  "Kavya Menon",
  "Aditya Sethi",
  "Neha Kapoor",
  "Harsh Vora",
  "Priya Malhotra",
  "Tanishq Gupta",
];

const productCatalog = [
  "Wireless Headphones",
  "Smart Watch",
  "Gaming Mouse",
  "Mechanical Keyboard",
  "Phone Case",
  "USB-C Charger",
  "Bluetooth Speaker",
  "Laptop Stand",
  "Fitness Band",
  "Portable SSD",
  "Desk Lamp",
  "Tablet Stand",
  "Backpack",
  "Water Bottle",
  "Power Bank",
  "Webcam",
  "Monitor Arm",
  "Earbuds",
  "HDMI Cable",
  "Smart Plug",
  "Mouse Pad",
  "Screen Protector",
  "Travel Adapter",
  "Mini Tripod",
  "Ring Light",
];

function padNumber(value, size = 5) {
  return String(value).padStart(size, "0");
}

function money(value) {
  return Math.round(value);
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function makeSvgDataUri(label, bg) {
  const safeLabel = label
    .split(" ")
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="160" height="160" viewBox="0 0 160 160">
      <defs>
        <linearGradient id="g" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0%" stop-color="${bg}" />
          <stop offset="100%" stop-color="#ffffff" stop-opacity="0.18" />
        </linearGradient>
      </defs>
      <rect width="160" height="160" rx="24" fill="url(#g)" />
      <circle cx="122" cy="34" r="34" fill="#ffffff" fill-opacity="0.12" />
      <text x="50%" y="56%" dominant-baseline="middle" text-anchor="middle" font-family="Arial, sans-serif" font-size="40" font-weight="700" fill="#ffffff">${safeLabel}</text>
    </svg>
  `;

  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

function buildProducts() {
  return productCatalog.map((name, index) => {
    const price = 349 + index * 137;
    const hue = (index * 31) % 360;
    return {
      id: `PROD-${padNumber(index + 1, 3)}`,
      sku: `SKU-${padNumber(index + 1, 3)}-${name
        .split(" ")
        .slice(0, 2)
        .map((part) => part[0])
        .join("")
        .toUpperCase()}`,
      name,
      category: index % 3 === 0 ? "Accessories" : index % 3 === 1 ? "Electronics" : "Lifestyle",
      price: money(price),
      image: makeSvgDataUri(name, `hsl(${hue} 72% 48%)`),
    };
  });
}

function buildCustomers() {
  return customerNames.map((name, index) => {
    const location = cities[index % cities.length];
    return {
      id: `CUS-${padNumber(index + 1, 3)}`,
      name,
      phone: `+91 ${padNumber(90000 + index * 137, 5)} ${padNumber(10000 + index * 73, 5)}`,
      email: `${name.toLowerCase().replace(/\s+/g, ".")}@example.com`,
      city: location.city,
      state: location.state,
      pincode: location.pincode,
      address: `${12 + index} ${["Palm Residency", "Lake View", "Sunrise Tower", "Orchid Heights"][index % 4]}, ${location.city}`,
      addresses: [
        `${12 + index} ${["Palm Residency", "Lake View", "Sunrise Tower", "Orchid Heights"][index % 4]}, ${location.city}`,
        `${44 + index} Market Street, ${location.city}`,
      ],
    };
  });
}

function buildOrders(products, customers) {
  const now = new Date();
  const statusCounts = {
    Pending: 0,
    Confirmed: 0,
    Packed: 0,
    Shipped: 0,
    Delivered: 0,
    Cancelled: 0,
    Returned: 0,
  };

  return Array.from({ length: 150 }, (_, index) => {
    const customer = customers[index % customers.length];
    const location = cities[index % cities.length];
    const status = statusOrder[index % statusOrder.length];
    statusCounts[status] += 1;

    const daysAgo = index % 60;
    const createdAt = new Date(now);
    createdAt.setDate(now.getDate() - daysAgo);
    createdAt.setHours(8 + (index % 10), (index * 13) % 60, 0, 0);

    const updatedAt = new Date(createdAt);
    updatedAt.setHours(createdAt.getHours() + clamp(index % 7, 1, 6));

    const isCod = index % 3 === 0;
    const courier = courierOptions[index % courierOptions.length];
    const selectedProducts = [
      products[index % products.length],
      products[(index + 7) % products.length],
    ].slice(0, index % 4 === 0 ? 1 : index % 4 === 1 ? 2 : 3);

    const items = selectedProducts.map((product, itemIndex) => ({
      id: `${product.id}-${itemIndex + 1}`,
      productId: product.id,
      name: product.name,
      sku: product.sku,
      image: product.image,
      qty: 1 + ((index + itemIndex) % 3),
      price: product.price + itemIndex * 89,
    }));

    const subtotal = items.reduce((sum, item) => sum + item.qty * item.price, 0);
    const discount = index % 5 === 0 ? money(subtotal * 0.08) : index % 7 === 0 ? 120 : 0;
    const shipping = status === "Cancelled" ? 0 : 79 + (index % 3) * 20;
    const tax = money((subtotal - discount) * 0.05);
    const total = money(subtotal - discount + shipping + tax);
    const deliveryDate = new Date(createdAt);
    deliveryDate.setDate(createdAt.getDate() + 2 + (index % 5));

    const paymentStatus =
      status === "Cancelled"
        ? "Failed"
        : status === "Returned"
        ? "Refunded"
        : isCod && status !== "Delivered"
        ? "Pending Collection"
        : "Paid";

    const paymentTransactionId = `${isCod ? "COD" : "TXN"}-${2026}-${padNumber(index + 2401, 6)}`;
    const trackingNumber = `${courier.name
      .split(" ")
      .map((part) => part[0])
      .join("")
      .toUpperCase()}-${padNumber(index + 45120, 6)}`;
    const returnStage = index % 11 === 0 ? "Requested" : index % 13 === 0 ? "Approved" : index % 17 === 0 ? "Picked" : index % 19 === 0 ? "Refunded" : null;
    const isDelayed = status === "Shipped" && index % 4 === 0;

    const notes = [
      {
        id: `note-${index}-1`,
        author: index % 2 === 0 ? "Operations" : "Support",
        timestamp: new Date(updatedAt.getTime() - 1000 * 60 * 60 * 4).toISOString(),
        body: "Initial review completed.",
      },
      {
        id: `note-${index}-2`,
        author: "Warehouse",
        timestamp: new Date(updatedAt.getTime() - 1000 * 60 * 35).toISOString(),
        body:
          status === "Pending"
            ? "Awaiting confirmation from the customer."
            : status === "Delivered"
            ? "Delivery confirmed and closed."
            : "Processed for next stage.",
      },
    ];

    const activity = [
      {
        id: `activity-${index}-1`,
        label: "Order placed",
        timestamp: createdAt.toISOString(),
      },
      {
        id: `activity-${index}-2`,
        label: `Status moved to ${status}`,
        timestamp: updatedAt.toISOString(),
      },
      ...(isDelayed
        ? [
            {
              id: `activity-${index}-3`,
              label: "Delay flagged by SLA monitor",
              timestamp: new Date(updatedAt.getTime() - 1000 * 60 * 30).toISOString(),
            },
          ]
        : []),
    ];

    return {
      id: `ORD-${2026}${padNumber(index + 12001, 5)}`,
      shortId: `#${padNumber(index + 1, 4)}`,
      createdAt: createdAt.toISOString(),
      updatedAt: updatedAt.toISOString(),
      status,
      paymentStatus,
      paymentMethod: isCod ? "COD" : "Prepaid",
      payment: {
        method: isCod ? "COD" : "Prepaid",
        status: paymentStatus,
        transactionId: paymentTransactionId,
        amountPaid: status === "Cancelled" ? 0 : total,
      },
      courier: {
        name: courier.name,
        awb: trackingNumber,
        trackingUrl: `https://tracking.example.com/${trackingNumber}`,
        slaHours: courier.slaHours,
        cost: courier.cost,
        rating: courier.rating,
        trackingTimeline: [
          { label: "Manifest created", timestamp: createdAt.toISOString() },
          { label: "Pickup scheduled", timestamp: new Date(createdAt.getTime() + 1000 * 60 * 60 * 12).toISOString() },
          {
            label:
              status === "Cancelled"
                ? "Order cancelled"
                : status === "Returned"
                ? "Returned to origin"
                : status === "Delivered"
                ? "Delivered"
                : "In transit",
            timestamp: updatedAt.toISOString(),
          },
        ],
      },
      customer: {
        id: customer.id,
        name: customer.name,
        phone: customer.phone,
        email: customer.email,
        city: customer.city,
        state: customer.state,
        pincode: customer.pincode,
        address: `${customer.address}, ${location.state}`,
        mapsQuery: `${customer.address}, ${location.city}, ${location.state} ${location.pincode}`,
      },
      items,
      notes,
      activity,
      pricing: {
        subtotal,
        discount,
        shipping,
        tax,
        total,
      },
      meta: {
        channel: ["Website", "Mobile App", "WhatsApp", "Marketplace"][index % 4],
        cod: isCod,
        highValue: total >= 5000,
        delayed: isDelayed,
        courierCost: courier.cost,
        courierSla: courier.slaHours,
        returnStage,
        deliveryEta: new Date(deliveryDate).toISOString(),
      },
      returnRequest:
        returnStage
          ? {
              id: `RET-${padNumber(index + 1, 4)}`,
              status: returnStage,
              reason:
                returnStage === "Requested"
                  ? "Customer changed mind"
                  : returnStage === "Approved"
                  ? "Item damaged in transit"
                  : returnStage === "Picked"
                  ? "Return picked by courier"
                  : "Refund issued",
              requestedAt: new Date(updatedAt.getTime() - 1000 * 60 * 60 * 8).toISOString(),
            }
          : null,
      notifications: [
        index % 5 === 0
          ? {
              id: `notif-${index}-1`,
              type: "New order",
              unread: index % 2 === 0,
            }
          : null,
      ].filter(Boolean),
    };
  });
}

function buildReturns(orders) {
  return orders
    .filter((order) => order.returnRequest)
    .slice(0, 15)
    .map((order, index) => ({
      id: order.returnRequest.id,
      orderId: order.id,
      customerName: order.customer.name,
      reason: order.returnRequest.reason,
      status: order.returnRequest.status,
      amount: order.pricing.total,
      requestedAt: order.returnRequest.requestedAt,
      courier: order.courier.name,
      city: order.customer.city,
      resolutionNote: index % 2 === 0 ? "Awaiting approval" : "Refund queued",
    }));
}

function buildNotifications(orders) {
  const templates = [
    { type: "New order", unread: true },
    { type: "Failed payment", unread: true },
    { type: "Delivery delay", unread: false },
    { type: "Return request", unread: true },
  ];

  const notifications = orders.slice(0, 30).map((order, index) => {
    const template = templates[index % templates.length];
    return {
      id: `notice-${index + 1}`,
      title: template.type,
      body:
        template.type === "New order"
          ? `${order.id} from ${order.customer.name}`
          : template.type === "Failed payment"
          ? `${order.id} needs payment review`
          : template.type === "Delivery delay"
          ? `${order.id} has a delayed SLA`
          : `${order.id} return ${order.returnRequest?.status || "Requested"}`,
      unread: template.unread && index % 2 === 0,
      timestamp: order.updatedAt,
    };
  });

  return notifications;
}

function buildAnalytics(orders, customers, products) {
  const statusBreakdown = statusOrder.map((status) => ({
    status,
    count: orders.filter((order) => order.status === status).length,
  }));

  const paymentSplit = [
    {
      name: "COD",
      value: orders.filter((order) => order.paymentMethod === "COD").length,
    },
    {
      name: "Prepaid",
      value: orders.filter((order) => order.paymentMethod === "Prepaid").length,
    },
  ];

  return {
    statusBreakdown,
    paymentSplit,
    customers,
    products,
    orderCount: orders.length,
  };
}

export function createBackOfficeSeed() {
  const products = buildProducts();
  const customers = buildCustomers();
  const orders = buildOrders(products, customers);
  const returns = buildReturns(orders);
  const notifications = buildNotifications(orders);

  return {
    products,
    customers,
    orders,
    returns,
    notifications,
    analytics: buildAnalytics(orders, customers, products),
  };
}

export function toCurrency(value) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(value);
}

export function toShortDate(value) {
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
  }).format(new Date(value));
}

export function toLongDate(value) {
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(value));
}

export function toDateTime(value) {
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

export function getStatusTone(status) {
  const tones = {
    Pending: { bg: "#fef3c7", color: "#b45309" },
    Confirmed: { bg: "#dbeafe", color: "#1d4ed8" },
    Packed: { bg: "#e0e7ff", color: "#4338ca" },
    Shipped: { bg: "#ede9fe", color: "#7c3aed" },
    Delivered: { bg: "#dcfce7", color: "#15803d" },
    Cancelled: { bg: "#fee2e2", color: "#b91c1c" },
    Returned: { bg: "#e5e7eb", color: "#374151" },
    Requested: { bg: "#fde68a", color: "#92400e" },
    Approved: { bg: "#bfdbfe", color: "#1d4ed8" },
    Picked: { bg: "#ddd6fe", color: "#6d28d9" },
    Refunded: { bg: "#d1fae5", color: "#047857" },
  };

  return tones[status] || { bg: "#eef2ff", color: "#4338ca" };
}

export function getPaymentTone(status) {
  const tones = {
    Paid: { bg: "#dcfce7", color: "#15803d" },
    "Pending Collection": { bg: "#fef3c7", color: "#b45309" },
    Refunded: { bg: "#e5e7eb", color: "#4b5563" },
    Failed: { bg: "#fee2e2", color: "#b91c1c" },
  };

  return tones[status] || { bg: "#e0e7ff", color: "#4338ca" };
}

export function getStatusFlow(status) {
  const steps = ["Pending", "Confirmed", "Packed", "Shipped", "Delivered"];
  const index = steps.indexOf(status);

  return steps.map((step, stepIndex) => ({
    label: step,
    completed: index >= stepIndex || status === "Cancelled" || status === "Returned",
    active: index === stepIndex,
    timestamp: index >= stepIndex ? true : false,
  }));
}
